<!--票据红冲-预收款列表-->
<template>
  <div>
    <div v-show="add_type == 1">
      <el-button style="margin-left: 1px" @click="modals">添加预收款</el-button>
      <el-button @click="del(1)">删除</el-button>
      <el-button @click="del(2)">全部删除</el-button>
      <el-button @click="searchs">搜索</el-button>
      <el-descriptions
        :column="2"
        border
        size="mini"
        style="margin-top: 10px"
        :labelStyle="{ width: '100px' }"
        :contentStyle="{ width: '43%' }"
      >
        <el-descriptions-item label="房产">
          <el-select
            v-model="select.text"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="可搜索房产"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width: 100%"
          >
            <el-option
              v-for="item in selectList"
              :key="item.id"
              :label="item.house"
              :value="item.house"
            ></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="客户名称">
          <el-input
            size="mini"
            v-model="select.name"
            clearable
            placeholder="客户名称"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="收费项目">
          <el-select
            v-model="select.chargeitem_id"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="收费项目"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width: 100%"
          >
            <el-option
              v-for="item in deposit_type"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-descriptions-item>
<!--        <el-descriptions-item label="是否存在余额">
          <Space direction="vertical" size="large">
            <RadioGroup v-model="select.money">
              <Radio label="是"></Radio>
              <Radio label="否"></Radio>
            </RadioGroup>
          </Space>
        </el-descriptions-item>-->
      </el-descriptions>
    </div>

    <div v-show="add_type == 2">
      <el-button style="margin-left: 1px" @click="add">保存</el-button>
      <el-button @click="tup">返回</el-button>
      <el-descriptions
        :column="2"
        border
        size="mini"
        style="margin-top: 10px"
        :labelStyle="{ width: '100px' }"
        :contentStyle="{ width: '43%' }"
      >
        <el-descriptions-item label="房产*" :labelStyle="{ color: 'red' }">
          <el-input
            class="cdj_input"
            v-model="form.house"
            placeholder="点击左边树选择房产"
            :disabled="true"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item
          label="选择客户*"
          :labelStyle="{ color: 'red' }"
        >
          <div style="display: flex">
            <el-input
              style="width: 80%"
              v-model="form.name"
              placeholder="客户姓名"
              :disabled="true"
            ></el-input>
            <el-button @click="user('')">选择客户</el-button>
          </div>
        </el-descriptions-item>
        <el-descriptions-item
          label="费用类型*"
          :labelStyle="{ color: 'red' }"
        >
          <el-select
            style="width: 100%"
            v-model="form.chargeitem_name_id"
            filterable
            placeholder="收费项目"
            class="kuan"
          >
            <el-option
              v-for="item in deposit_type"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item
          label="发生额(元)*"
          :labelStyle="{ color: 'red' }"
        >
          <el-input v-model="form.money" placeholder="金额"></el-input>
        </el-descriptions-item>
        <el-descriptions-item
          label="结算方式*"
          :labelStyle="{ color: 'red' }"
        >
          <el-select
            style="width: 100%"
            v-model="form.payment_name"
            filterable
            placeholder="结算方式"
            class="kuan"
          >
            <el-option
              v-for="item in payment"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="票据类型" :labelStyle="{ color: 'red' }">
          <el-select
            style="width: 100%"
            v-model="form.bill_type"
            @change="selects"
            filterable
            placeholder="票据类型"
            class="kuan"
          >
            <el-option
              v-for="item in bill_type"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="票据号码" :labelStyle="{ color: 'red' }">
          <el-input
            class="cdj_input"
            v-model="form.bill_number"
            placeholder="票据号码"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <el-date-picker
            v-model="form.startDate"
            type="date"
            style="width: 47%"
            placeholder="开始日期"
          ></el-date-picker>
          <span style="margin-left: 1px; margin-right: 1px">至</span>
          <el-date-picker
            v-model="form.endDate"
            type="date"
            style="width: 47%"
            placeholder="结束日期"
          ></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          <el-input
            class="cdj_input"
            v-model="form.remarks"
            placeholder="请输入"
          ></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div style="margin-top: 10px;">
      <span>选中金额：<span style="color: red;">{{money_val ? money_val : 0}}</span>元</span>
      <span style="margin-left: 15px;">总金额：<span style="color: red;">{{money}}</span>元</span>
      <span style="margin-left: 15px;color: red;" v-if="loading">加载中...</span>
    </div>
    <el-table
      ref="multipleTable"
      :height="height"
      :data="data"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" > </el-table-column>
      <el-table-column prop="id" label="ID" width="90" />
      <el-table-column prop="name" label="客户姓名" width="130">
        <template slot-scope="data">
          <el-tooltip class="item" effect="light" :content="data.row.customer_id" placement="right">
            <span>{{ data.row.name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="house" label="房产" />
      <el-table-column prop="chargeitem_name" label="收费项目" width="130" />
      <el-table-column prop="money" label="金额" width="80" />
      <el-table-column label="结算方式" width="150">
        <template slot-scope="data">
          {{ data.row.payment_name }}
          <el-button
            style="color: #1e73e9"
            size="mini"
            @click="editPaymentName(data.row)"
          >修改</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" />
    </el-table>
    <v-divider></v-divider>
    <div class="pages" v-if="data">
      <el-pagination @size-change="changeSize"
                     @current-change="handleCurrentChange"
                     :current-page="select.page"
                     :page-sizes="[20,100,200,500,1000]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="count">
      </el-pagination>
    </div>
    <div class="zhanwu" v-else>没有数据</div>

    <Modal
      v-model="modal4"
      ok-text="保存"
      width="600"
      :loading="loadingModal"
      :mask-closable="maskclosable"
      :mask="maskclosable"
      title="修改结算方式"
      @on-ok="alterPaymentName"
    >
      <div>
        <el-form style="height: 600px; overflow: auto">
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>结算方式</span>
            <div class="cdj_input">
              <el-select
                style="width: 100%"
                v-model="form.payment_name"
                filterable
                placeholder="结算方式"
                class="kuan"
              >
                <el-option
                  v-for="item in payment"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form>
      </div>
    </Modal>

    <!-- 弹窗选择用户 -->
    <Modal v-model="modal1" width="800" title="选择客户" @on-ok="roomUser">
      <div>
        <room-user
          style="height: 600px"
          ref="child"
          :house="house_1"
        ></room-user>
      </div>
    </Modal>

  </div>
</template>

<script>
  import ViewFlow from "../../Common/ViewFlow.vue";

  export default {
    // 接受父组件的值
    props: {

    },
    watch:{

    },
    components: {
      "erp-tree": () => import('../../Common/erp-tree-adiust.vue'),
      "room-user": () => import('../../Common/room-user.vue'),
    },
    data() {
      return {
        user_update: "",
        money: 0,
        money_val: 0,
        height: "50vh",
        add_type: 1,
        select: {
          text: "",
          name: "",
          chargeitem_id: "",
          money: "",
        },
        house_1: "",
        selectList: [],
        project_id: "",
        datevalue: [],
        maskclosable: false,
        modal1: false,
        modal: false,
        modal2: false,
        modal3: false,
        modal4: false,
        modal5: false,
        statesModal: false,
        loading: false,
        loadingModal: true,
        unlinkpanels: true,
        options: [],
        payment: [],
        charge: [],
        house: [],
        count: 0,
        pageSize: 12,
        data: [],
        pid: "",
        text: "",
        state: "1",
        url: "",
        fileList: [],
        form: {
          customer_id: "",
          startDate: "",
          endDate: "",
          pindex_id: "",
          house_id: "",
          name: "",
          house: "",
          payment_name: "",
          chargeitem_name_id: "",
          money: "",
          bill_type: "",
          bill_number: "",
          remarks: "",
          startDate: "",
          endDate: "",
          is_chang_time: ERP.isPermission(4003010002) ? 1 : 0
        },
        statesForm: {
          id: "",
          payment_name: "",
          retreat_money: "",
          retreat_date: "",
          remarks: "",
        },
        houseForm: {
          advance_id: "",
          house_id: "",
        },
        deposit_type: [],
        date: "",
        bill_type: [
          {
            id: 1,
            name: "收据",
          },
          {
            id: 2,
            name: "中奥收据",
          },
          {
            id: 3,
            name: "电子发票",
          },
          {
            id: 4,
            name: "资金往来发票",
          },
          {
            id: 5,
            name: "定额发票20元",
          },
          {
            id: 6,
            name: "增值税专用发票",
          },
          {
            id: 7,
            name: "服务业通用发票",
          },
          {
            id: 8,
            name: "停车场专用发票",
          },
          {
            id: 9,
            name: "红字发票",
          },
          {
            id: 10,
            name: "增值税普通发票",
          },
          {
            id: 11,
            name: "定额发票5元",
          },
          {
            id: 12,
            name: "系统导入票据",
          },
          {
            id: 13,
            name: "定额发票1元",
          },
          {
            id: 14,
            name: "中奥-收据",
          },
        ],
        detaileds: [],
        deposit: [],
        capitalize: "",
        login: "",
        advance_id: "",
        detailed_id: "",
        invoiceVisable: false,
      };
    },
    mounted() {
      var login = window.localStorage.getItem("login");
      var token = window.localStorage.getItem("token");
      this.url =
        this.$myhttp.defaults.baseURL +
        "/admin/excel?" +
        "login_name=" +
        login +
        "&token=" +
        token;
      //项目列表
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          this.options = backdata.data.data;
        });
      //加载收款方式
      this.$myhttp
        .get("admin/common/payment", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          this.payment = backdata.data.data;
        });

    },
    //事件
    methods: {
      //作废
      tup() {
        this.add_type = 1;
        this.height = "50vh";
      },
      getInvo(house,pid){
        console.log('house',house);
        console.log('pid',pid);
        this.project_id = pid;
        this.select.text = house;
        this.form.house = house;
        this.change(1);
        /*if(this.tadd == 2){
          this.$refs.billRedFlushTemporaryAdd.pids(this.pid,this.house);
        }*/

        this.form.pindex_id = pid;
        let _this = this;
        this.form.bill_type = "";
        this.form.bill_number = "";
        this.form.money = "";
        this.money = 0;
        this.money_val = 0;

        //收费项
        this.$myhttp
          .get("admin/common/p_chargeitem_name?pid=" + pid, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.deposit_type = backdata.data.data;
          });

        this.tableDatas(pid, house);
      },
      roomSet(it){
        let _this = this;
        if (it.type == "room") {
          _this.form.name = it.customerName;
          _this.form.house_id = it.id;
          // _this.tableDatas(tree[0].id, tree_str);
        } else {
          _this.form.name = it.customerName;
          _this.form.house_id = 0;
          // _this.tableDatas(tree[0].id, tree_str);
        }
      },
      remoteMethod(query) {
        if (query !== "") {
          // console.log(query);
          let datas = {"text": query, "project_id": this.project_id};
          this.loading = true;
          this.$myhttp
            .post(
              "admin/common/house_text",
              datas,
              {
                "Content-Type": "application/x-www-form-urlencoded",
              }
            )
            .then((backdata) => {
              // 异步执行成功后
              this.selectList = backdata.data.data;
              this.loading = false;
            });
        } else {
          this.selectList = [];
        }
      },
      selects(e) {
        if (this.form.bill_type == "" || this.form.bill_type == null) {
          this.form.bill_number = "";
          return false;
        }
        if (this.form.pindex_id == "" || this.form.pindex_id == null) {
          return false;
        }
        if (e == "收据" || e == "中奥收据" || e == "中奥-收据") {
          let pindex_id = this.form.pindex_id;
          this.$myhttp
            .get("admin/common/getBills?pindex_id=" + pindex_id, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              let data = backdata.data.data;
              this.form.bill_number = data.top + data.number + data.bill;
            });
        } else {
          this.form.bill_number = "";
        }
      },
      //数字转大写
      transCnMoney(number) {
        var CN_MONEY = "";
        var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
        number = parseFloat(number).toFixed(2).toString(); //浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
        var dot = number.indexOf("."); //将从小数点开始分开
        if (dot >= 0) {
          number = number.substring(0, dot) + number.substr(dot + 1, 2);
          CN_UNIT = CN_UNIT.substr(CN_UNIT.length - number.length);
          for (var i = 0; i < number.length; i++) {
            CN_MONEY +=
              "零壹贰叁肆伍陆柒捌玖".substr(number.substr(i, 1), 1) +
              CN_UNIT.substr(i, 1);
          }
          return CN_MONEY.replace(/零角零分$/, "整")
            .replace(/零[仟佰拾]/g, "零")
            .replace(/零{2,}/g, "零")
            .replace(/零([亿|万])/g, "$1")
            .replace(/零+元/, "元")
            .replace(/亿零{0,3}万/, "亿")
            .replace(/^元/, "零元");
        } else {
        }
      },

      //树搜索
      nodeClick1(data) {
        //console.log(data);
        let project = data.tree[0];
        this.project_id = project.pindex_id;
        let tree_str = data.tree
          .map((ret) => {
            return ret.name;
          })
          .join("->");
        this.select.text = tree_str;
        this.form.house = tree_str;
        this.change(1);
        let tree = data.tree;
        // console.log(tree)
        this.form.pindex_id = tree[0].id;
        let _this = this;
        this.form.bill_type = "";
        this.form.bill_number = "";
        this.form.money = "";
        this.money = 0;
        tree.forEach(function (it) {
          if (it.type == "room") {
            _this.form.name = it.customerName;
            _this.form.house_id = it.id;
            _this.tableDatas(tree[0].id, tree_str);
          } else {
            _this.form.name = it.customerName;
            _this.form.house_id = 0;
            _this.tableDatas(tree[0].id, tree_str);
          }
        });
        //收费项
        this.$myhttp
          .get("admin/common/p_chargeitem_name?pid=" + this.project_id, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.deposit_type = backdata.data.data;
          });
      },
      modals() {
        this.add_type = 2;
        this.height = 400;
        this.select.money = "是";
        // this.modal = true;
      },
      //保存
      add() {
        if (this.form.name == "") {
          this.$Message.error("客户姓名不能为空!");
          this.loadingModals();
          return false;
        }
        if (this.form.house_id == 0) {
          this.$Message.error("点击左边树选择房产");
          this.loadingModals();
          return false;
        }
        if (this.form.house == "") {
          this.$Message.error("点击左边树选择房产");
          this.loadingModals();
          return false;
        }
        if (this.form.payment_name == "") {
          this.$Message.error("结算方式不能为空!");
          this.loadingModals();
          return false;
        }
        if (this.form.chargeitem_name_id == "") {
          this.$Message.error("费用类型不能为空!");
          this.loadingModals();
          return false;
        }
        if (this.form.money == "") {
          this.$Message.error("金额不能为空!");
          this.loadingModals();
          return false;
        }
        if (this.form.bill_type == "") {
          this.$Message.error("票据类型不能为空!");
          this.loadingModals();
          return false;
        }
        if (this.form.bill_number == "") {
          this.$Message.error("票据号码不能为空!");
          this.loadingModals();
          return false;
        }
        ERP.showLoading();
        this.$myhttp
          .post("admin/OrderBillRedFlushFlow/advance_add", this.form, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            ERP.hideLoading();
            // 异步执行成功后
            this.modal = false;
            if (backdata.data.code == 201) {
              this.dialogVisible = false;
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              },err=>{});
            }
            if (backdata.data.code == 200 || backdata.data.code == 202) {
              this.form.money = "";
              this.form.bill_type = "";
              this.form.bill_number = "";
              this.modal = false;
              this.change(1);
              this.$Message.success("提交成功!");
            }
          });
      },
      //删除
      del(e){
        if(this.project_id == ''){
          //this.$Message.error('点击左边树选择项目');
          this.$confirm('点击左边树选择项目', '提示', {
            confirmButtonText: '关闭',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { })
          return false;
        }
        this.$confirm('确定操作吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.showLoading()
          /*let chargeitemID = '';
          if(this.chargeitemID.length >=1){
            chargeitemID = this.chargeitemID.map(req=>{return req;}).join(',');
          }*/
          let data = {
            'text': this.select.text,
            'pid': this.project_id,
            'searchMode': 2,
            'chargeitemID': this.select.chargeitem_id,
            'user': this.select.name,
            'type': e,
            'order': this.order
          }
          console.log('data',data);
          // let data = {'data':search_data,'house':this.house,'pid':this.pid,'type':e,'order':this.order}
          this.$myhttp.post('admin/OrderBillRedFlushFlow/advance_del',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            // this.change(this.page);
            this.change(1);
            //调用父组件方法
            // this.$parent.selects(1);

            if(backdata.data.code == 201){
              // this.$Message.error(backdata.data.message);
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '关闭',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => { })
              // return false;
            }
            if(backdata.data.code == 200){
              this.$Message.success('操作成功!');
            }

          },err=>{
            ERP.hideLoading()
            this.$Message.error('请求异常!');
          });
        })
      },

      oks() {
        this.modal2 = false;
      },
      //分页
      change(page) {
        console.log('4003010002',ERP.isPermission(4003010002));
        console.log('4003010005',ERP.isPermission(4003010005));
        this.loading = true;
        this.money = 0;
        this.select.page = page;
        this.select.pageSize = this.pageSize;
        this.select.state = this.state;
        this.select.pid = this.project_id;
        this.$myhttp
          .post("admin/OrderBillRedFlushFlow/advance_index", this.select, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then(
            (backdata) => {
              // 异步执行成功后
              this.loading = false;
              if (backdata.data.code == 201) {
                this.$Message.error(backdata.data.message);
              } else {
                let data = backdata.data;
                this.data = data.data.data;
                this.count = data.data.count;
                // this.pageSize = data.data.pageSize;
                this.date = data.data.date;
                this.money = data.data.money;
              }
            },
            (err) => {
              this.loading = false;
              this.$Message.error("请求异常!");
            }
          );
      },
      handleCurrentChange(e){
        // this.page = e;//第几页
        this.change(e);
      },
      changeSize(e){
        this.pageSize = e;
        this.change(1);
      },
      //搜索
      searchs() {
        this.money = "--";
        this.change(1);
      },
      handleSelectionChange(val){
        this.order = val;
        let money = 0;
        this.order.map(req=>{
          money = Number(money) + Number(req.money);
        })
        this.money_val = money.toFixed(2);
      },
      //弹窗不要关闭
      loadingModals() {
        let _this = this;
        _this.loadingModal = false;
        setTimeout(() => {
          _this.loadingModal = true;
        }, 10);
      },
      editPaymentName(it) {
        this.advance_id = it.id;
        this.form = {
          pindex_id: it.pindex_id,
          house_id: it.house_id,
          name: it.name,
          house: it.house,
          payment_name: it.payment_name,
          chargeitem_name_id: it.chargeitem_name_id,
          money: "",
          bill_type: "",
          bill_number: "",
          remarks: "",
          startDate: it.startDate,
          endDate: it.endDate,
          customer_id: it.customer_id,
          is_chang_time: ERP.isPermission(4003010002) ? 1 : 0
        };
        this.datevalue = [];
        if (it.startDate) {
          this.datevalue = [it.startDate, it.endDate];
        }
        this.modal4 = true;
      },
      alterPaymentName() {
        if (this.form.payment_name == "") {
          this.$Message.error("结算类型不能为空!");
          this.loadingModals();
          return false;
        }
        this.form.advance_id = this.advance_id;
        this.loading = true;
        this.$myhttp
          .post("admin/OrderBillRedFlushFlow/editAdvancePaymentName", this.form, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            if (backdata.data.code == 200) {
              // 异步执行成功后
              this.loadingModals();
              this.loading = false;
              this.$Message.success("操作成功!");
              this.change(1);
              this.modal4 = false;
            } else {
              this.loadingModals();
              this.loading = false;
              this.$Message.error(backdata.data.msg);
              this.modal4 = false;
            }
          });
      },
      //选择客户
      user(data) {
        this.user_update = data;
        this.house_1 = this.select.text;
        this.modal1 = true;
      },
      roomUser() {
        let user = this.$refs.child.getUser();
        //console.log(user);
        if (user.id) {
          this.form.customer_id = user.id;
          this.form.name = user.name;
        }
      },
      tableDatas(pid, tree_str) {
        let datas = {"house": tree_str};
        this.$myhttp
          .post("admin/OrderBillRedFlushFlow/temp_house", datas, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            //console.log(backdata.data);
            if (backdata.data.customer != "") {
              this.form.customer_id = backdata.data.customer[0].id;
              this.form.name = backdata.data.customer[0].name;
            } else {
              this.form.name = "";
            }
          });
      },
    },
  }
</script>

<style>
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #3e3f42 !important;
  cursor: not-allowed;
}
.my-label {
  color: red;
}
</style>

<style scoped>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  position: fixed;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/billRedFlushAdvance.vue